export default (() => {

  class MainNavigationMobile {
    constructor() {
      this.$body = $('body');
      this.$hamburger = $('.main-navigation-mobile-hamburger');
      this.$hamburgerIcon = $('.hamburger');
      this.$mobileNavigationContent = $('.main-navigation-mobile-content');
      this.$mobileNavigationSlider = $('.main-navigation-mobile-slider');
      this.$mobileNavigationSliderWasActive = $('.main-navigation-mobile-slider.was-active');
      this.$mobileNavigationLevelOneItem = $('.main-navigation-mobile-l1-item');
      this.$mobileNavigationLevelOneArrow = $('.main-navigation-mobile-l1-arrow');
      this.$mobileNavigationLevelNoLink = $('.main-navigation-mobile-l1-nolink');
      this.$mobileNavigationLevelTwoBack = $('.main-navigation-mobile-l2-back');
      this.$mobileNavigationLevelTwoItem = $('.main-navigation-mobile-l2-item');
      this.$mobileNavigationLevelTwoArrow = $('.main-navigation-mobile-l2-arrow');
      this.$mobileNavigationLevelThreeBack = $('.main-navigation-mobile-l3-back');
    }

    expandMenu($this) {
      $this.closest(this.$hamburger).attr('aria-expanded', true);
      $this.closest(this.$hamburger).find(this.$hamburgerIcon).addClass('is-active');
      $this.closest(this.$hamburger).find(this.$hamburgerIcon).attr('aria-label', 'Close mobile navigation');
      this.$body.addClass('main-navigation-mobile-active');
      this.$mobileNavigationContent.addClass('active');
      this.$mobileNavigationContent.find(this.$mobileNavigationSlider).eq(0).addClass('active');
    }

    collapseMenu($this) {
      $this.closest(this.$hamburger).attr('aria-expanded', false);
      $this.closest(this.$hamburger).find(this.$hamburgerIcon).removeClass('is-active');
      $this.closest(this.$hamburger).find(this.$hamburgerIcon).attr('aria-label', 'Open mobile navigation');
      this.$body.removeClass('main-navigation-mobile-active');
      this.$mobileNavigationContent.removeClass('active');
    }

    openMenu(e) {
      const $this = $(e.target);
      if ($this.closest(this.$hamburger).attr('aria-expanded') === 'false') {
        this.expandMenu($this);
      } else if ($this.closest(this.$hamburger).attr('aria-expanded') === 'true') {
        this.collapseMenu($this);
      }
    }

    openSliderLevelOne(e) {
      e.preventDefault();
      const $this = $(e.target);
      $this.closest(this.$mobileNavigationSlider).removeClass('active').addClass('was-active').scrollTop(0);
      $this.closest(this.$mobileNavigationLevelOneItem).find(this.$mobileNavigationSlider).eq(0).addClass('active').scrollTop(0);
    }

    openSliderLevelTwo(e) {
      e.preventDefault();
      const $this = $(e.target);
      $this.closest(this.$mobileNavigationSlider).removeClass('active').addClass('was-active').scrollTop(0);
      $this.closest(this.$mobileNavigationLevelTwoItem).find(this.$mobileNavigationSlider).eq(0).addClass('active').scrollTop(0);
    }

    closeSliderLevelTwo(e) {
      e.preventDefault();
      const $this = $(e.target);
      $this.parents('.main-navigation-mobile-slider.was-active').first().removeClass('was-active').addClass('active');
      $this.closest(this.$mobileNavigationSlider).removeClass('active');
    }

    closeSliderLevelThree(e) {
      e.preventDefault();
      const $this = $(e.target);
      $this.parents('.main-navigation-mobile-slider.was-active').first().removeClass('was-active').addClass('active');
      $this.closest(this.$mobileNavigationSlider).removeClass('active');
    }

    init() {
      this.$hamburger.on('click', (e) => this.openMenu(e));
      this.$mobileNavigationLevelOneArrow.on('click', (e) => this.openSliderLevelOne(e));
      this.$mobileNavigationLevelNoLink.on('click', (e) => this.openSliderLevelOne(e));
      this.$mobileNavigationLevelTwoArrow.on('click', (e) => this.openSliderLevelTwo(e));
      this.$mobileNavigationLevelTwoBack.on('click', (e) => this.closeSliderLevelTwo(e));
      this.$mobileNavigationLevelThreeBack.on('click', (e) => this.closeSliderLevelThree(e));
    }
  }

  const mainNavigationMobile = new MainNavigationMobile();
  mainNavigationMobile.init();

  // Abe: The above code is amazingly convoluted so not gonna touch it.
  // Just gonna add what I need here so I can ask the nav to close itself 
  window.closeMobileMenu = () => {
    if($('body').hasClass('main-navigation-mobile-active')){
      mainNavigationMobile.collapseMenu(mainNavigationMobile.$hamburger)
      return true
    }
    return false
  }


})()

